import { useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Cookies from 'js-cookie';
import { useAuth } from 'lib/auth';
import storage from 'utils/storage';
import { Button } from 'components/Elements';
import { VerificationCodeInputField } from 'components/Form';
import { REMOTE_URLS } from 'config/remotes';
import { loginWithGoogleAuthenticator } from '../api/googleAuthLogin';

export const GoogleAuthForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const inputRefs = useRef(new Array(6).fill(null));
  const [verificationCode, setVerificationCode] = useState();

  const { login } = useAuth();
  const navigate = useNavigate();

  const cookieData = Cookies.get('loginData');

  const parsedCookieData = JSON.parse(cookieData);

  const handleVerify = async () => {
    setVerifying(true);
    setError('');
    try {
      const data = {
        email: parsedCookieData.user,
        authenticatorCode: verificationCode,
      };
      const response = await loginWithGoogleAuthenticator(data);

      if (response) {
        setSuccess(true);
        onSuccess();
      }
    } catch (err) {
      setError('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="">
      <div className="">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          A 6-digit code has been sent to your authenticator app.
        </label>
        <div className="flex space-x-2 justify-start mb-3 w-full">
          <VerificationCodeInputField
            length={6}
            onChange={(code) => setVerificationCode(code)}
          />
        </div>
      </div>
      <div className="w-full">
        <Button
          className="w-full mb-3"
          onClick={handleVerify}
          disabled={verifying || verificationCode === 6}
        >
          {verifying ? 'Verifying...' : 'Verify'}
        </Button>
      </div>
    </div>
  );
};

export default GoogleAuthForm;
